module.exports = __webpack_public_path__ + "static/media/XBOXGAMEPAS.cdb42e8b.svg";